/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppSchemasOfferFloorIn
 */
export interface AppSchemasOfferFloorIn {
    /**
     * 
     * @type {string}
     * @memberof AppSchemasOfferFloorIn
     */
    floors: string;
}

export function AppSchemasOfferFloorInFromJSON(json: any): AppSchemasOfferFloorIn {
    return AppSchemasOfferFloorInFromJSONTyped(json, false);
}

export function AppSchemasOfferFloorInFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppSchemasOfferFloorIn {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'floors': json['floors'],
    };
}

export function AppSchemasOfferFloorInToJSON(value?: AppSchemasOfferFloorIn | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'floors': value.floors,
    };
}


